export const text = {
  common: {
    autoUpdate: "Auto-update",
    loading: "Loading...",
    error: "error",
    search: "Search",
    searchPlaceholder: "Search for surveys...",
    searchPlaceholderForDetails: "Search for questions and variables...",
    searchPlaceholderForDashbaord: "Search by dashboard name or client name...",
    searchPlaceholderForDataset: "Search for Dataset name...",
    cancel: "Cancel",
    refresh: "Refresh",
    import: "Import",
    tryAgain: "Try Again",
    reloadPage: "Reload Page",
    signOut: "Sign Out",
    account: "Account",
    logout: "Logout",
    all: "All",
    name: "Name",
    state: "State",
    status: "Status",
    actions: "Actions",
    link: "Link",
    responses: "Responses",
    surveys: "surveys",
    datasets: "datasets",
    oneDataset: "dataset",
    updateList: "Update list",
    createDataset: "Create Dataset",
    createNewDashboard: "Create New Dashboard",
    addSelectedToDataset: "Add selected to dataset",
    refreshSelected: "Refresh selected",
    importSelected: "Import selected",
    showArchivedDatasets: "Show archived datasets",
    showArchivedDashboards: "Show archived dashboards",
    pending: "Pending",
    ready: "Ready",
    failed: "Failed",
    inProgress: "In Progress",
    queued: "Queued",
    unknown: "Unknown",
    rename: "Rename",
    dataset: "Dataset",
    dashboards: "dashboards",
    dashboard: "dashboard",
    ok: "OK",
  },
  navigation: {
    surveys: "Surveys",
    datasets: "Datasets",
    settings: "Settings",
    support: "Support",
    help: "Help",
  },
  pages: {
    datasets: {
      title: "Datasets",
      viewSampleDatasetDetails: "View Sample Dataset Details",
      noDataMessage: "No datasets available.",
    },

    surveys: {
      title: "Surveys",
      imported: "Imported",
      all: "All",
    },
    settings: {
      title: "Settings",
      welcomeMessage: "Welcome to the settings page!",
    },
    support: {
      title: "Support",
      welcomeMessage: "Welcome to the support page!",
    },
    login: {
      title: "Login",
      subtitle: "Please log in to access the dashboard.",
      loginButton: "Login with Auth0",
      loggingIn: "Logging in...",
      emailVerificationError:
        "Your email address has not been verified. Please check your email and click the verification link before logging in.",
      errorPrefix: "Error: ",
    },
    verifyEmail: {
      title: "Email Verification Required",
      message:
        "Please verify your email address to access the application. We've sent a verification email to",
      instructions:
        "Check your inbox and click the verification link to continue.",
    },
    datasetDetails: {
      goBackAriaLabel: "Go back to datasets",
      datasetCreated: "Dataset created",
      lastModified: "Last modified",
      totalResponses: "Total responses",
      totalSurveys: "Total surveys",
      surveysSection: "Surveys",
      details: "Details",
      questions: "Questions",
      crosstabs: "Crosstabs",
      reports: "Reports",
      archiveDataset: "Archive dataset",
      renameDataset: "Rename Dataset",
      clientCompany: "Client company",
    },
    dashboards: {
      title: "Dashboards",
      lastModified: "Last modified",
      lastAccessed: "Last accessed",
      primaryClient: "Primary client",
      actions: "Actions",
      noDataMessage: "No dashboards created yet.",
      noDataSubMessage: "Click 'Create New Dashboard' to get started.",
      noDataMessageForClient:
        "Sorry, no dashboards are currently shared with you. If you think this is a mistake please contact your researcher at Harris Poll.",
      noSearchDataMessage: "No dashboards found matching your search.",
      noSearchDataSubMessage: "Try searching with different keywords.",
      archiveDashboard: "Archive dashboard",
    },
  },
  surveys: {
    tableHeaders: {
      lastAccessed: "Last Accessed",
      responseCount: "Responses",
      lastUpdated: "Last Updated",
      importStatus: "Import Status",
      status: "Status",
      actions: "Actions",
      name: "Name",
    },
    states: {
      live: "Live",
      closed: "Closed",
      draft: "Draft",
    },
    filterOptions: {
      all: "All",
      live: "Live",
      closed: "Closed",
      draft: "Draft",
    },
    importedTab: {
      noDataMessage: "No surveys have been imported yet.",
      noDataSubMessage:
        "Go to the {allSurveysLink} page to start importing surveys.",
      allSurveysLink: "All Surveys",
      createDatasetTooltip: "First select surveys to create a dataset",
    },
    allTab: {
      noDataMessage: "No survey found.",
      noDataSubMessage: "Try to search with different wording.",
    },
  },
  datasets: {
    tableHeaders: {
      surveys: "Surveys",
      responses: "Responses",
      lastModified: "Last modified",
      created: "Created",
      archive: "Actions",
    },
  },
  jobStates: {
    failed: "Failed",
    ready: "Ready",
    inProgress: "In Progress",
    queued: "Queued",
    unknown: "Unknown",
  },
  table: {
    sortedDescending: "sorted descending",
    sortedAscending: "sorted ascending",
  },
  errorBoundary: {
    title: "Something went wrong",
    message:
      "An unexpected error occurred. Please try refreshing the page or contact support if the problem persists.",
    reloadPage: "Reload Page",
    tryAgain: "Try Again",
    errorDetailsTitle: "Error Details (Development Only):",
  },
  modals: {
    importSurveys: {
      title: "Importing multiple surveys",
      message:
        "You are about to start the import of {count} surveys. Continue?",
      partialMessage: "{available} out of {total} surveys can be imported.",
      unavailableTitle:
        "The following surveys are already imported or in progress:",
      noAvailableTitle: "No surveys available for import",
      noAvailableMessage:
        "All selected surveys are already imported or in progress.",
      confirmButton: "Import",
      importRestButton: "Import the rest of surveys",
      cancelButton: "Cancel",
    },
    updateSurveysList: {
      title: "Update surveys list?",
      message: "Update will clear the current survey selections. Continue?",
      confirmButton: "Update",
      cancelButton: "Cancel",
    },
    selectDatasetForSurveys: {
      title: "Select dataset to add surveys",
      confirmButton: "Add Surveys",
    },
    noAvailableSurveysToAdd: {
      title: "No surveys to add",
      message:
        "All {count} of the selected surveys are already in a dataset. Please deselect them and choose new ones to continue.",
      cancelButton: "Cancel",
    },
    noDatasets: {
      title: "No datasets available",
      message: "You have no existing datasets. Create a new one to continue.",
      confirmButton: "Create",
    },
    publishDashboard: {
      title: "Publish dashboard?",
      message:
        "You are about to publish this dashboard with {count} tabs. Continue?",
      confirmButton: "Publish",
    },
    unpublishDashboard: {
      title: "Unpublish dashboard?",
      message:
        "This dashboard is shared with {count} client users. If you confirm, they will no longer have access until it is published again.",
      messageNoUsers:
        "This dashboard has not been shared with any clients yet. If you confirm, it will be returned to a draft state.",
      confirmButton: "Unpublish",
    },
  },
  messages: {
    success: {
      surveyImportRequested: "Survey import requested successfully!",
      multiplesurveysImportRequested:
        "{count} surveys import requested successfully!",
      surveyRefreshRequested: "Survey refresh requested successfully!",
      surveysListUpdated: "Surveys list updated successfully!",
      datasetCreated: "Dataset successfully created.",
      surveysAddedToDataset: "Surveys successfully added to dataset.",
      chartCreated: "Visualization widget saved.",
      chartUpdated: "Visualization updated.",
      dashboardPublished: "Dashboard published.",
      dashboardDuplicated:
        "Dashboard duplicated successfully. '{dashboardName}' is ready for editing.",
      dashboardUnpublished: "Returned to draft.",
      dashboardShared_one: "Dashboard shared with 1 account.",
      dashboardShared_many: "Dashboard shared with {count} accounts.",
      newUsersInvited_one: "1 new user invited successfully!",
      newUsersInvited_many: "{count} new users invited successfully!",
      accessRevoked: "Access revoked for {userName}.",
    },
    info: {
      surveysAlreadyImported:
        "{count} surveys were already imported and skipped",
    },
    error: {
      failedToFetchSurveys: "Failed to fetch surveys",
      failedToFetchImportedSurveys: "Failed to fetch imported surveys",
      failedToImportSurvey: "Failed to import survey",
      failedToImportSelectedSurveys: "Failed to import selected surveys",
      failedToRefreshSurvey: "Failed to refresh survey",
      failedToRefreshSurveys: "Failed to refresh surveys",
      failedToCreateDataset: "Failed to create dataset",
      surveysAlreadyInDataset:
        "Some selected surveys are already in a dataset. Please deselect them to continue.",
      failedToCreateDashboard: "Failed to create dashboard.",
      failedToDuplicateDashboard:
        "Dashboard duplication failed. Please try again or contact support.",
      failedToPublishDashboard: "Failed to publish dashboard.",
      failedToUnpublishDashboard: "Failed to unpublish dashboard.",
      failedToInviteUsers: "Failed to invite new users.",
      failedToShareDashboard:
        "Failed to share dashboard with existing accounts.",
      failedToRevokeAccess: "Failed to revoke access for {userName}.",
    },
  },
  dataAvailability: {
    helperText:
      "Set the date through which data is ready for client-facing reporting. Charts will use this date to determine the latest complete period for time-based visualizations.",
    notSet: "Not set. Uses latest date with data in the dataset.",
    warningText:
      "Available Through is earlier than the earliest date with data. Some or all complete periods may be unavailable.",
    afterMaxWarningText:
      "Available Through is later than the latest date with data. The summary below reflects what is actually available.",
    summaryTitle: "Complete Period Summary",
    summaryRows: [
      { key: "semester", label: "Last complete Semester" },
      { key: "quarter", label: "Last complete Quarter" },
      { key: "month", label: "Last complete Month" },
      { key: "week", label: "Last complete Week" },
    ],
  },
  ariaLabels: {
    openProfileMenu: "Open profile menu",
    openInNewWindow: "Open in New Window",
    importSurvey: "Import Survey",
    refreshSurvey: "Refresh Survey",
    createDataset: "Create Dataset",
    refresh: "Refresh",
    importStatus: "Import Status",
    state: "State",
    jobStatus: "Job status: {status}",
    datasetStatus: "Dataset status",
    moreOptions: "More options",
    createNewDashboard: "Create New Dashboard",
  },
};
